import type {} from "@mui/x-data-grid/themeAugmentation";
import type {} from "@mui/lab/themeAugmentation";

import { createTheme } from "@mui/material/styles";
import variables from "../scss/_variables.scss";

const theme = createTheme({
    typography: {
        fontSize: 15,
    },
    components: {
        MuiLink: {
            styleOverrides: {
                root: {
                    textDecoration: "none",
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                filledInfo: {
                    backgroundColor: "#C8DEE2",
                },
            },
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    color: "#757575",
                },
            },
        },
    },
    palette: {
        text: {
            primary: "#000",
            secondary: "#757575",
        },
        primary: {
            main: variables.primaryColor,
        },
        secondary: {
            main: variables.secondaryColor,
            contrastText: variables.primaryColor,
        },
        info: {
            main: "#673AB7",
        },
        error: {
            main: "#D32F2F",
            light: "#DCABAB",
        },
        divider: "#BDBDBD",
    },
    customComponents: {
        infoBox: {
            backgroundColor: "#F3E5F6",
            accentColor: "#673AB7",
        },
    },
});

export default theme;
